module.exports = __webpack_public_path__ + "media/decapitate.c7e4183d.webm";